import { cn } from '@/lib/utils';

/**
 * Marketing section header (design-system/README.md › Section header):
 * eyebrow in forest, H2 in brand-900 with balanced wrapping, optional lead line.
 * Pass `id` to label the section with `aria-labelledby`.
 */
export function SectionHeader({
  eyebrow, title, description, id, align = 'center', className,
}: {
  eyebrow: string;
  title: string;
  description?: string;
  id?: string;
  align?: 'center' | 'left';
  className?: string;
}) {
  return (
    <div className={cn('max-w-2xl mb-10 sm:mb-12', align === 'center' ? 'mx-auto text-center' : 'text-left', className)}>
      <p className="text-sm font-semibold uppercase tracking-wider text-primary mb-3">{eyebrow}</p>
      <h2 id={id} className="text-3xl sm:text-4xl font-bold text-brand-900 tracking-tight [text-wrap:balance]">{title}</h2>
      {description && <p className="mt-4 text-lg text-slate-600 leading-relaxed">{description}</p>}
    </div>
  );
}
